<!--cowork_wb 整合其中的mindmap 到Sharing本站，可響應HT協議-->
<template >
    <div>   
        <MindMap :isTool="isTool" />
    </div>
</template>
<script>
import { ref, onMounted } from 'vue';
import MindMap from './MindMap.vue';
export default {
    name: "HTwbMind",
    components: {
        MindMap
    },
    setup() {
       
        const isTool = ref(false); // 判斷mindmap 是否為預編工具

        onMounted(() => {
            // Parse URL to check if mode=mindMap
            const urlParams = new URLSearchParams(window.location.search);
            isTool.value = urlParams.has('isTool') && urlParams.get('isTool') === 'true' ? true : false;
        });

        return {
            isTool
        };
    },
}
</script>
<style lang="less">
    
</style>